<div class="details-tab">
  <div class="row">
    <!-- Left Column -->
    <div class="col-md-6">


      <div class="form-group">
        <label for="name" class="col-md-6 control-label">NAME</label>
        <div class="col-md-6 inputSpace">
          <input type="text"
                 id="name"
                 class="form-control"
                 [(ngModel)]="location.name"
                 [disabled]="!isEditMode"
                 (ngModelChange)="onFieldChange()"
                 placeholder="Location Name" />
        </div>
      </div>

      <div class="form-group">
        <label for="address" class="col-md-6 control-label">ADDRESS</label>
        <div class="col-md-6 inputSpace">
          <input type="text"
                 id="address"
                 class="form-control"
                 [(ngModel)]="location.address"
                 [disabled]="!isEditMode"
                 (ngModelChange)="onFieldChange()"
                 placeholder="Address" />
        </div>
      </div>

      <div class="form-group">
        <label for="city" class="col-md-6 control-label">CITY</label>
        <div class="col-md-6 inputSpace">
          <input type="text"
                 id="city"
                 class="form-control"
                 [(ngModel)]="location.city"
                 [disabled]="!isEditMode"
                 (ngModelChange)="onFieldChange()"
                 placeholder="City" />
        </div>
      </div>
      <div class="form-group">
        <label for="country" class="col-md-6 control-label">COUNTRY</label>
        <div class="col-md-6 inputSpace">
          <p-dropdown [(ngModel)]="location.countryAbbreviation"
                      [options]="countries"
                      optionLabel="name"
                      optionValue="abbreviation"
                      placeholder="Select Country"
                      [disabled]="!isEditMode"
                      (onChange)="onCountryChange()"
                      [style]="{'width': '100%'}"
                      inputId="country">
          </p-dropdown>
        </div>
      </div>

      <div class="form-group">
        <label for="state" class="col-md-6 control-label">STATE</label>
        <div class="col-md-6 inputSpace">
          <p-dropdown [(ngModel)]="location.stateAbbreviation"
                      [options]="states"
                      optionLabel="abbreviation"
                      optionValue="abbreviation"
                      placeholder="Select State"
                      [disabled]="!isEditMode"
                      (onChange)="onFieldChange()"
                      [style]="{'width': '100%'}"
                      inputId="state">
          </p-dropdown>
        </div>
      </div>

      <div class="form-group">
        <label for="zip" class="col-md-6 control-label">ZIP</label>
        <div class="col-md-6 inputSpace">
          <input type="text"
                 id="zip"
                 class="form-control"
                 [(ngModel)]="location.zipcode"
                 [disabled]="!isEditMode"
                 (ngModelChange)="onFieldChange()"
                 placeholder="Zip Code" />
        </div>
      </div>
      <div class="form-group">
        <label for="locId" class="col-md-6 control-label">LOCATION ID</label>
        <div class="col-md-6 inputSpace">
          <input type="text"
                 id="locId"
                 class="form-control"
                 [(ngModel)]="location.locId"
                 [disabled]="!isEditMode"
                 (ngModelChange)="onFieldChange()"
                 placeholder="Location ID" />
        </div>
      </div>
    </div>

    <!-- Right Column -->
    <div class="col-md-6">
      <div class="checkbox-group">
        <div class="checkbox-item">
          <p-checkbox [(ngModel)]="location.isShipper"
                      [binary]="true"
                      inputId="shipper"
                      [disabled]="!isEditMode"
                      (onChange)="onFieldChange()">
          </p-checkbox>
          <label for="shipper" class="checkbox-label">SHIPPER</label>
        </div>

        <div class="checkbox-item">
          <p-checkbox [(ngModel)]="location.isConsignee"
                      [binary]="true"
                      inputId="consignee"
                      [disabled]="!isEditMode"
                      (onChange)="onFieldChange()">
          </p-checkbox>
          <label for="consignee" class="checkbox-label">CONSIGNEE</label>
        </div>

        <div class="checkbox-item">
          <p-checkbox [(ngModel)]="location.isBillTo"
                      [binary]="true"
                      inputId="billTo"
                      [disabled]="!isEditMode"
                      (onChange)="onFieldChange()">
          </p-checkbox>
          <label for="billTo" class="checkbox-label">BILL TO</label>
        </div>
      </div>

      <div class="coordinates-section">
        <div class="coordinates-wrapper">
          <div class="coordinates-inputs">
            <div class="form-group">
              <label for="latitude" class="col-md-6 control-label">LATITUDE</label>
              <div class="col-md-6 inputSpace">
                <input type="number"
                       id="latitude"
                       class="form-control"
                       [(ngModel)]="location.latitude"
                       [disabled]="!isEditMode"
                       (ngModelChange)="onFieldChange()"
                       placeholder="Latitude"
                       step="any" />
              </div>
            </div>

            <div class="form-group">
              <label for="longitude" class="col-md-6 control-label">LONGITUDE</label>
              <div class="col-md-6 inputSpace">
                <input type="number"
                       id="longitude"
                       class="form-control"
                       [(ngModel)]="location.longitude"
                       [disabled]="!isEditMode"
                       (ngModelChange)="onFieldChange()"
                       placeholder="Longitude"
                       step="any" />
              </div>
            </div>

            <div class="form-group">
              <label for="timezone" class="col-md-6 control-label">TIMEZONE</label>
              <div class="col-md-6 inputSpace">
                <p-dropdown [(ngModel)]="location.timezone"
                            [options]="timezoneOptions"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select Timezone"
                            [disabled]="!isEditMode"
                            (onChange)="onFieldChange()"
                            [style]="{'width': '100%'}"
                            inputId="timezone">
                </p-dropdown>
              </div>
            </div>
          </div>

          <button type="button"
                  class="btn btn-default location-pin-btn"
                  (click)="onLocationPinClick()"
                  title="Geocode Location">
            <i class="fa fa-map-marker"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Location Coordinates Dialog -->
  <p-dialog [(visible)]="displayLocationDialog"
            header="Location Coordinates"
            [modal]="true"
            [style]="{width: '600px'}"
            [draggable]="false"
            [resizable]="false"
            (onShow)="onDialogShow()"
            (onHide)="onDialogHide()">
    <div class="dialog-content">
      <div class="coordinate-display" style="margin-bottom: 10px;">
        <label><strong>Latitude:</strong></label>
        <span>{{ location.latitude || 'Not set' }}</span>
      </div>
      <div class="coordinate-display" style="margin-bottom: 15px;">
        <label><strong>Longitude:</strong></label>
        <span>{{ location.longitude || 'Not set' }}</span>
      </div>
      <google-map [center]="mapCenter"
                  [zoom]="mapZoom"
                  [options]="mapOptions"
                  (mapClick)="onMapClick($event)"
                  style="width: 100%; height: 100%;">
        <map-marker *ngIf="markerPosition"
                    [position]="markerPosition"
                    [options]="markerOptions"
                    (mapDragend)="onMarkerDragEnd($event)">
        </map-marker>
      </google-map>
    </div>

    <ng-template pTemplate="footer">
      <button class="btn btn-default" (click)="closeLocationDialog()">Close</button>
    </ng-template>
  </p-dialog>
</div>

